document.addEventListener("turbolinks:load", function () {
    const guideSection = document.getElementById("annualElectionGuideSection");
    if (!guideSection) return; // Only run this on the right page

    // Map of aria-label values to target element IDs
    const linksToHeaders = {
      "Initial Requirements": "initial_requirements",
      "Hybrid/Electronic Voting Requirement": "electronic_consent_notice",
      "Nomination Forms": "nomination_forms",
      "Pre-Ballot Notifications": "pre_ballot_notification",
      "Ballots": "ballots",
      "Results": "results"
    };

    Object.entries(linksToHeaders).forEach(([ariaLabel, targetId]) => {
      const link = document.querySelector(`a[aria-label="${ariaLabel}"]`);
      const target = document.getElementById(targetId);

      if (link && target) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          // Account for fixed header offset
          const headerOffset = 100;
          const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        });
      }
    });
  });
